import { Box, ListItemIcon, Menu } from "@mui/material";
import React from "react";
import { useTranslation } from 'react-i18next'
import { languages } from "../../../utils/i18n/languages/languages";
import { CustomItem, CustomMenuItem, Image, LanguageButton, ResponsiveTextLanguage, ResponsiveIconLanguage } from "./style";
import LanguageIcon from '@mui/icons-material/Language';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useColors } from "../../../Context/ColorsContext";

export const LanguageSelect = ({ insideApp = true }) => {
    const { i18n, t } = useTranslation(); 
    const [language, setLanguage] = React.useState(languages[0]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { colors } = useColors();

    React.useEffect(() => {
        let lang = localStorage.getItem("lang")
        if (lang !== null) {
            let filtered = languages.filter((el) => el.value === lang)[0]
            i18n.changeLanguage(lang)
            setLanguage(filtered);
        }
    }, [])

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
  
    const handleClose = (value) => {
        setAnchorEl(null);
        if (value.value) {
            setLanguage(value);
            i18n.changeLanguage(value.value)
            localStorage.setItem("lang", value.value)
        }
    };

    return (
        <>
        {language !== null &&
            <LanguageButton onClick={handleOpen} insideApp={insideApp}>
                <Box display="flex" alignItems="center" gap="6px">
                    <LanguageIcon />
                    <ResponsiveTextLanguage>
                        <CustomItem>{t(`language.${language.value}`)}</CustomItem>
                    </ResponsiveTextLanguage>
                </Box>
                <ResponsiveIconLanguage fontSize="small" />
            </LanguageButton>
        }
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 1,
                            borderRadius: '8px',
                            minWidth: 140,
                            boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
                            border: `1px solid ${colors.grayFont}`
                        },
                    },
                }}
            >
                {languages.map((option, key) => {
                    const isSelected = option.value === language?.value;
                    return (
                        <CustomMenuItem value={option.value} key={key} onClick={() => handleClose(option)}>
                            <CustomItem>{t(`language.${option.value}`)}</CustomItem>
                            {isSelected && (
                                <ListItemIcon sx={{ minWidth: 24 }}>
                                    <CheckCircleOutlineIcon fontSize="small" />
                                </ListItemIcon>
                            )}
                        </CustomMenuItem>
                    )
                })}
            </Menu>
        </>
    );
}
